module.exports = __webpack_public_path__ + "img/v4_trade2.57580503.png";